export const STATE_STATUSES = {
  active: 'active',
  upcoming: 'upcoming',
  closed: 'closed',
  nominationUpcoming: 'nominationUpcoming',
  nominationStarted: 'nominationStarted',
  nominationClosed: 'nominationClosed',
}

export const getEventStateStatus = (eventState, votingOpen, nominationState = 'disabled') => {
  if (votingOpen == null) return
  if (votingOpen) return STATE_STATUSES.active
  if (eventState === 'started' && !votingOpen) return STATE_STATUSES.closed
  if (['created'].includes(eventState)) {
    if (['enabled', 'upcoming'].includes(nominationState)) return STATE_STATUSES.nominationUpcoming
    if (nominationState === 'started') return STATE_STATUSES.nominationStarted
    if (['ended'].includes(nominationState)) return STATE_STATUSES.nominationClosed
    if (['disabled', 'sealed'].includes(nominationState)) return STATE_STATUSES.upcoming
    return STATE_STATUSES.upcoming
  }
  if (['finalized'].includes(eventState)) return STATE_STATUSES.upcoming
  if (['ended', 'decrypting', 'decrypted', 'tallied'].includes(eventState)) return STATE_STATUSES.closed
  return STATE_STATUSES.closed
}
